import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import checkboxTrue from './content/checkbox_true.png';
import checkboxFalse from './content/checkbox_false.png';
import checkboxIndeterminate from './content/checkbox_indeterminate.png';

class Checkbox extends Component {
    static defaultProps = {forcedState:""};
    
    constructor(props) {
        super(props);        
        this.state = {checkState:0}; // 0 == indeterminate, 1 == true, 2 == false
    }
    
    componentDidMount() {
        if (this.props.indeterminate === true) {
            this._setIndeterminate(true);
        }
    }
    
    componentDidUpdate(previousProps) {
        if (previousProps.indeterminate !== this.props.indeterminate) {
            this._setIndeterminate(this.props.indeterminate);
        }
    }
    
    _setIndeterminate(indeterminate) {
        const node = ReactDOM.findDOMNode(this);
        node.indeterminate = indeterminate;
    }

    changeState(value=-1) {
        if (this.props.forcedState !== "") {
            return;
        }
        
        let x = this.state.checkState;
        
        if(value > -1) {
            x = value;
        } else {
            x = (x + 1) % 3;
        }
        this.setState({checkState:x});
        this._setIndeterminate(x===0);

        if (typeof this.props.updated === "function") {
            switch(x) {
            case 0:
                this.props.updated("indeterminate");
                break;

            case 1:
                this.props.updated("true");
                break;

            case 2:
                this.props.updated("false");
                break;

            default:
                break;
            }
            
        }
    }
    
    render() {
        const { forcedState, indeterminate, type, updated, ...props } = this.props;
        let img = checkboxIndeterminate;
        
        if (forcedState !== "") {
            switch(forcedState) {
            case "true":
                img = checkboxTrue;
                break;

            case "false":
                img = checkboxFalse;
                break;

            case "indeterminate":
                img = checkboxIndeterminate;
                break;

            default:
                break;
            }
        } else {
            if (this.state.checkState === 1) {
                img = checkboxTrue;
            } else if (this.state.checkState === 2) {
                img = checkboxFalse;
            }
        }
        
        return <img className="checkbox" src={img} onClick={this.changeState.bind(this)} {...props} alt={this.state.checkState} />;
        //return <input type="checkbox" checked={this.state.checkState===1} onClick={this.changeState.bind(this)} {...props} />;
    }
}

export default Checkbox;
